import { createFileRoute } from "@tanstack/react-router";

import { PurchasesListPage } from "@/modules/purchases/pages/PurchasesList.page";

export const Route = createFileRoute("/__authed/m/purchases/")({
	component: PurchasesListPage,
});
